import { waitForElement } from '@ardoq/common-helpers';
import { TOUR_ANCHOR_TIMEOUT_MS } from './timings';

/** Waits for a tour anchor for as long as a step is given to find one. */
export const waitForTourAnchor = (
  selector: string
): Promise<HTMLElement | null> =>
  waitForElement(selector, TOUR_ANCHOR_TIMEOUT_MS);

export const isOffScreen = (element: HTMLElement): boolean => {
  const rect = element.getBoundingClientRect();
  return (
    rect.bottom <= 0 ||
    rect.right <= 0 ||
    rect.top >= window.innerHeight ||
    rect.left >= window.innerWidth ||
    (rect.width === 0 && rect.height === 0)
  );
};

/**
 * Centers normal-sized targets; for elements taller than most of the viewport,
 * aligns the top instead so we don't scroll their top off-screen (e.g. the tall
 * Insights section).
 */
export const scrollAnchorIntoView = (element: HTMLElement): void => {
  const isTall =
    element.getBoundingClientRect().height > window.innerHeight * 0.6;
  element.scrollIntoView({
    block: isTall ? 'start' : 'center',
    inline: 'nearest',
  });
};
